module.exports = "/images/JR-Mall-Left-Arrow.svg";